import { createElement } from "react";
import { toast as sonnerToast } from "sonner";

import { ToastCustom, type ToastTone } from "@/components/alia/toast-custom";

export type { ToastTone };

interface ToastOptions {
  id?: string;
  description?: string;
  duration?: number;
}

const DEFAULT_DURATION: Record<ToastTone, number> = {
  success: 3000,
  error: 5000,
  info: 4000,
};

function show(
  tone: ToastTone,
  message: string,
  opts: ToastOptions = {}
): string | number {
  const duration = opts.duration ?? DEFAULT_DURATION[tone];
  return sonnerToast.custom(
    (id) =>
      createElement(ToastCustom, {
        id,
        tone,
        title: message,
        description: opts.description,
        onClose: () => sonnerToast.dismiss(id),
      }),
    { id: opts.id, duration }
  );
}

export const toast = {
  error: (m: string, opts?: ToastOptions) => show("error", m, opts),
  success: (m: string, opts?: ToastOptions) => show("success", m, opts),
  info: (m: string, opts?: ToastOptions) => show("info", m, opts),
  dismiss: (id?: string | number) => sonnerToast.dismiss(id),
};
